import repository from '@/core/repository/repository'
import uuid from 'uuid/v4'
import constants from '@/core/constants'
import httpService from '@/core/http-service'
import authorizationService from '@/core/auth/authorization-service'
import localizationService from '@/core/services/localization-service'
import _ from 'lodash'
import store from '@/store'

function create(currentUserCompany) {
  const channel = authorizationService.getClaim('channel')
  const propertyManagementIsoCode = _.get(currentUserCompany, 'isoCodes.pickedKeys[0]')
  const currentUnitCountry = localizationService.getCountryByCompany(currentUserCompany)
  const countryCallingCode = _.get(store.getters.languages[propertyManagementIsoCode], 'iso3166Country.dialCodes[0]', '')
  const submittedRequest = repository.create('submittedRequest', { request:
    {
      external_id_1: uuid(),
      access_group: authorizationService.getClaim('access_group'),
      channel_in: channel,
      channel_out: channel
    }
  })
  if(currentUserCompany) {
    if(currentUserCompany.isSubUnit) {
      submittedRequest.request.sub_unit = currentUserCompany.companyId
    } else {
      submittedRequest.request.prp_company = currentUserCompany.companyId
    }
    submittedRequest.request.order_type = currentUserCompany.orderType
  }
  const businessPartner = repository.create('contact', {
    email: authorizationService.getClaim('unique_name'),
    name: authorizationService.getClaim('display_name'),
    phone: authorizationService.getClaim('phone'),
    contact_type: _.get(currentUserCompany, 'companyRepository.companyContactType')
  })
  const damagePlace = repository.create('damagePlace', {
    phone_number: `+${countryCallingCode}`,
    addresses: [
      repository.create('address', { address_type: constants.addressType.default, country: currentUnitCountry }),
      repository.create('address', { address_type: constants.addressType.billTo, country: currentUnitCountry })
    ]
  })

  submittedRequest.request.contacts.push(businessPartner)
  submittedRequest.request.dmg_place = damagePlace

  store.dispatch('tryAddEntity', { type: 'createdErrand', key: submittedRequest.request.external_id_1, data: submittedRequest })

  return submittedRequest
}

function submit(submittedRequest) {
  return httpService.post('errands', submittedRequest)
}

export default { create, submit }
